function HookedLogo() {
  return (
    <img
      height="180"
      width="140"
      src="/logos/hooked-logo.png"
      className="w-full h-full object-contain"
      alt="Hooked Logo"
      loading="eager"
      decoding="async"
    />
  );
}

export { HookedLogo };
